import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import Panel from '../components/Panel';
import RecentFilesTable from '../components/RecentFilesTable';

const RecentFilesPage = ({ historyVersion }) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    let active = true;
    axios.get('/api/files').then(response => {
      if (active) setFiles(response.data.files || []);
    }).catch(() => {
      if (active) setFiles([]);
    });
    return () => { active = false; };
  }, [historyVersion]);

  return (
    <Box sx={{ maxWidth: 1440, mx: 'auto' }}>
      <Typography variant="caption" color="text.secondary">Files</Typography>
      <Typography component="h1" variant="h5" sx={{ fontWeight: 750, mb: 2 }}>Recent files</Typography>
      <Panel title="Shared with your team" action={<Typography variant="caption" color="text.secondary">Kept 24 hours</Typography>} bodySx={{ p: 0 }}>
        <RecentFilesTable files={files} showAllFiles emptyMessage="No files have been converted yet." />
      </Panel>
    </Box>
  );
};

export default RecentFilesPage;
